import { runtimeConfig } from "@src/runtime-config";

/** Dashboard identifier to pass to all APIs as header "X-Holobuilder-Component" */
export const CLIENT_ID = `sphere-dashboard/${runtimeConfig.appVersion}`;